import React, { useMemo, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link"],
    ["clean"]
  ]
};

const QUILL_FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "indent",
  "link"
];

const tabBtn = (active) =>
  [
    "rounded-md px-3 py-1.5 text-xs font-medium transition-colors",
    active ? "bg-white text-[#064E8D] shadow-sm" : "text-gray-600 hover:text-gray-900"
  ].join(" ");

/**
 * Rich HTML field with Quill (snow) for edit and a read-only preview that uses `.ql-editor` styling
 * so output matches typical Quill-rendered content in the app.
 */
const FreightAppDrawerHtmlField = ({ label, value, onChange, helpText }) => {
  const [mode, setMode] = useState("edit");

  const previewHtml = useMemo(() => {
    const v = String(value ?? "").trim();
    return v || "<p class=\"text-gray-400 italic\">Empty</p>";
  }, [value]);

  return (
    <div className="freight-app-drawer-html-field space-y-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <label className="m-0 text-sm font-medium text-gray-700">{label}</label>
        <div className="inline-flex rounded-lg border border-gray-200 bg-gray-100 p-0.5" role="tablist" aria-label={`${label} mode`}>
          <button type="button" role="tab" aria-selected={mode === "edit"} className={tabBtn(mode === "edit")} onClick={() => setMode("edit")}>
            Edit
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={mode === "preview"}
            className={tabBtn(mode === "preview")}
            onClick={() => setMode("preview")}
          >
            Preview
          </button>
        </div>
      </div>
      {helpText ? <p className="m-0 text-xs text-gray-500">{helpText}</p> : null}

      {mode === "edit" ? (
        <div className="freight-app-drawer-quill overflow-hidden rounded-lg border border-gray-200 bg-white">
          <ReactQuill
            theme="snow"
            value={value}
            onChange={onChange}
            modules={QUILL_MODULES}
            formats={QUILL_FORMATS}
            placeholder="Type something…"
          />
        </div>
      ) : (
        <div className="ql-snow freight-drawer-html-preview rounded-lg border border-gray-200 bg-white">
          <div className="ql-editor min-h-[200px] px-4 py-3 text-sm" dangerouslySetInnerHTML={{ __html: previewHtml }} />
        </div>
      )}
    </div>
  );
};

export default FreightAppDrawerHtmlField;
